import type { ComponentProps } from 'react';
import { cn } from '../../common/functions/cn';

const Kbd = ({ className, ...props }: ComponentProps<'kbd'>) => {
  return (
    <kbd
      data-slot="kbd"
      className={cn(
        'pointer-events-none inline-flex h-5 w-fit min-w-5 select-none items-center justify-center gap-1 px-1',
        'rounded-sm bg-muted font-medium font-sans text-muted-foreground text-xs',
        // The tooltip surface is the foreground colour in dark mode, so the key has to invert with it.
        'in-data-[slot=tooltip-content]:bg-foreground/10 in-data-[slot=tooltip-content]:text-foreground',
        'dark:in-data-[slot=tooltip-content]:bg-background/10 dark:in-data-[slot=tooltip-content]:text-background',
        "[&_svg:not([class*='size-'])]:size-3",
        className
      )}
      {...props}
    />
  );
};

const KbdGroup = ({ className, ...props }: ComponentProps<'kbd'>) => {
  return <kbd data-slot="kbd-group" className={cn('inline-flex items-center gap-1', className)} {...props} />;
};

export { Kbd, KbdGroup };
